function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0833 7.37012H0.916667C0.410667 7.37012 0 7.78078 0 8.28678V19.2501C0 20.7663 1.23383 22.0001 2.75 22.0001H19.25C20.7662 22.0001 22 20.7663 22 19.2501V8.28678C22 7.78078 21.5893 7.37012 21.0833 7.37012Z",
  fill: "#ECEFF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.25 2.75H2.75C1.23108 2.75 0 3.98108 0 5.5V8.28667H22V5.5C22 3.98108 20.7689 2.75 19.25 2.75Z",
  fill: "#2196F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11 8.28662H0V19.25C0 20.7661 1.23383 22 2.75 22H11V8.28662Z",
  fill: "#CDD0D2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 2.75H2.75C1.23108 2.75 0 3.98108 0 5.5V8.28667H11V2.75Z",
  fill: "#1D83D4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4163 0H16.4997C15.9937 0 15.583 0.410667 15.583 0.916667V4.58333C15.583 5.08933 15.9937 5.5 16.4997 5.5H17.4163C17.9223 5.5 18.333 5.08933 18.333 4.58333V0.916667C18.333 0.410667 17.9223 0 17.4163 0Z",
  fill: "#1976D2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.958 0H16.4997C15.9937 0 15.583 0.410667 15.583 0.916667V4.58333C15.583 5.08933 15.9937 5.5 16.4997 5.5H16.958V0Z",
  fill: "#1667B7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.50033 0H4.58366C4.07766 0 3.66699 0.410667 3.66699 0.916667V4.58333C3.66699 5.08933 4.07766 5.5 4.58366 5.5H5.50033C6.00633 5.5 6.41699 5.08933 6.41699 4.58333V0.916667C6.41699 0.410667 6.00633 0 5.50033 0Z",
  fill: "#1976D2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.04199 0H4.58366C4.07766 0 3.66699 0.410667 3.66699 0.916667V4.58333C3.66699 5.08933 4.07766 5.5 4.58366 5.5H5.04199V0Z",
  fill: "#1667B7"
});

var SvgAgenda = function SvgAgenda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgenda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agenda.056f7f45.svg";
export { ForwardRef as ReactComponent };